import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { createRange } from './rang';
function createFormModel(vm) {
  return {
    // 加班日期
    ot_date_at: '',
    // 加班类型ID
    ot_setting_id: '',
    // 加班开始时间
    ot_start_time: '',
    // 加班结束时间
    ot_end_time: '',
    // 加班时长（自动计算）
    ot_duration: '',
    // 加班备注
    ot_audit_reason: ''
  };
}
function createFormRule(vm) {
  return {
    ot_setting_id: {
      required: true,
      message: vm.$t('i18n.st3AxhXiV26W'),
      trigger: 'change'
    },
    ot_start_time: {
      required: true,
      message: vm.$t('i18n.st3AxhXiV26W'),
      trigger: 'change'
    },
    ot_end_time: {
      required: true,
      message: vm.$t('i18n.st3AxhXiV26W'),
      trigger: 'change'
    },
    ot_audit_reason: {
      required: true,
      message: vm.$t('i18n.st3AxhXiV26W'),
      trigger: 'change'
    }
  };
}
export default {
  data: function data() {
    return {
      loading: false,
      dialogVisible: false,
      params: '',
      form: createFormModel(this),
      rules: createFormRule(this),
      overTimeTypeOptions: [],
      pickerOptions: {},
      over_time: {},
      messages: []
    };
  },
  methods: {
    init: function init(params) {
      var _this = this;
      this.params = params;
      this.dialogVisible = true;
      var staff_id = params.staff_id,
        attendance_date = params.attendance_date;
      this.form.ot_date_at = attendance_date;
      this.pickerOptions = createRange(this.form.ot_date_at);
      this.$http({
        url: '/web/over_time/getOverTimeInit',
        data: {
          staff_id: staff_id
        }
      }).then(function (res) {
        _this.overTimeTypeOptions = res.data.types;
      });
    },
    checkTime: function checkTime() {
      var s = parseInt(this.form.ot_start_time.replace(/-|:|\s/g, ''));
      var e = parseInt(this.form.ot_end_time.replace(/-|:|\s/g, ''));
      if (s >= e) {
        this.$message.warning(this.$t('i18n.741b9e823d8a4340a1e92d774095ccd4'));
        return false;
      }
      return true;
    },
    calculateOverTime: function calculateOverTime() {
      var _this2 = this;
      var _this$form = this.form,
        ot_date_at = _this$form.ot_date_at,
        ot_setting_id = _this$form.ot_setting_id,
        ot_start_time = _this$form.ot_start_time,
        ot_end_time = _this$form.ot_end_time;
      if (ot_setting_id && ot_start_time && ot_end_time) {
        var staff_id = this.params.staff_id;
        var data = {
          staff_id: staff_id,
          ot_date_at: ot_date_at,
          ot_setting_id: ot_setting_id,
          ot_start_time: ot_start_time,
          ot_end_time: ot_end_time
        };
        if (!this.checkTime()) return;
        this.$http({
          url: '/web/over_time/calculateOverTime',
          data: data
        }).then(function (res) {
          _this2.form.ot_duration = res.data.over_time.over_time_hour;
          _this2.over_time = res.data.over_time || {};
          _this2.messages = [].concat(_toConsumableArray(_this2.over_time.deduction_details || []), _toConsumableArray(_this2.over_time.alert_details || []));
        }).catch(function () {
          _this2.form.ot_duration = '';
          _this2.over_time = {};
          _this2.messages = [];
        });
      } else {
        this.form.ot_duration = '';
        this.over_time = {};
        this.messages = [];
      }
    },
    submit: function submit() {
      var _this3 = this;
      this.$refs.ElForm.validate(function (valid) {
        if (valid) {
          if (!_this3.checkTime()) return;
          var staff_id = _this3.params.staff_id;
          _this3.loading = true;
          _this3.$http({
            url: '/web/over_time/add',
            data: _objectSpread(_objectSpread({
              staff_id: staff_id
            }, _this3.form), {}, {
              ot_duration: _this3.over_time.over_time_duration
            })
          }).then(function () {
            _this3.dialogVisible = false;
            _this3.$emit('update');
          }).finally(function () {
            _this3.loading = false;
          });
        }
      });
    },
    handleClosed: function handleClosed() {
      this.$refs.ElForm.resetFields();
      this.form.ot_duration = '';
      this.over_time = {};
      this.messages = [];
    }
  }
};